import * as React from "react";
import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { AppBar, Box, CssBaseline, Stack, Toolbar, useMediaQuery } from "@mui/material";
import useScrollTrigger from '@mui/material/useScrollTrigger';

import Header from "./Header";
import Footer from "./Footer";

interface Props {
  window?: () => Window;
  children?: any;
}

function ElevationScroll(props: Props) {
  const ismobile = !useMediaQuery('(min-width:800px)');
  const { children, window } = props;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
    style: {
      background: trigger ? '#171844e0' : 'transparent',
      boxShadow:
        !ismobile && trigger ? '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)' : 'none',
    }
  });
}

const MainLayout = (props: Props) => {

  const header = useMemo(
    () => (
      <Toolbar>
        <Header />
      </Toolbar>
    ),
    []
  );

  return (
    <Stack>
      <CssBaseline />
      <ElevationScroll {...props}>
        <AppBar
          sx={{
            zIndex: 100,
            transition: '0.5s',
            '& .MuiToolbar-root': {
              px: '0px !important',
            }
          }}
        >
          {header}
        </AppBar>
      </ElevationScroll>
      <Box>
        <Outlet />
      </Box>
      <Footer />
    </Stack>
  );
};

export default MainLayout;
